
import React, { useEffect, useState } from "react"
import { Button, Container } from "reactstrap"
import "react-multi-carousel/lib/styles.css"

import { useLocation, useNavigate, useParams } from "react-router-dom"
import awicon from "../../assets/images/services-icon/coin.png"
import piratemale from "../../assets/images/profile-avatars/avatar1/piratemale.png"
import piratefemale from "../../assets/images/profile-avatars/avatar2/piratefemale.png"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// @ts-ignore
import Loader from "react-spinner-loader"
import { BASE_URL } from "../../global"
import { ActivityUtil } from "../../modules/lesson/activity/activity-util"
import { AvatarData, AvatarHeadData } from "../../modules/avatar/avatar.types"
import { LessonActivity, LessonActivityOnetime } from "../../modules/lesson/activity/lesson-activity.types"

type HandledActivityTypes = LessonActivityOnetime

interface OneTimeActivityProps {}
const OneTimeActivity = (props: OneTimeActivityProps) => {
  const { key } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null

  let pk_activity_key = null
  let isHomework: boolean = false;

  if (key && key.length >= 16 && type && homework) {
    pk_activity_key = key
    isHomework = parseInt(homework) === 1
  } else {
    window.history.back()
  }

  const [loader, setLoader] = useState(false)
  const [activityData, setActivityData] = useState<HandledActivityTypes>()

  //Timmere start

  const [seconds, setSeconds] = useState(0)
  const [isRunning, setIsRunning] = useState(false)

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isRunning) {
      timer = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1)
      }, 1000)
    }

    return () => clearInterval(timer)
  }, [isRunning])

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60)
    const remainingSeconds = time % 60
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`
  }

  const handleToggleTimer = () => {
    setIsRunning(prevState => !prevState)
  }

  const handleResetTimer = () => {
    setSeconds(0)
    setIsRunning(true)
  }

  //Timer end
  //task

  const authUser = JSON.parse(localStorage.getItem("authStudentUser") || null!)
  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location])

  const fetchAttendanceData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentSession/StudentAttendance", {
            pk_activity_key: pk_activity_key,
          })
          .then(responseAttendance => {})
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        window.history.back()
      }
    } else {
      navigate("/login")
    }
  }

  const fetchData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
        setLoader(true)
        setActivityData(undefined)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentSession/StudentAssessmentQuestions", {
            pk_activity_key: pk_activity_key,
            subject_id: type,
          })
          .then(responseActivity => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            setLoader(false)
            console.info(responseActivity.data)

            if (responseActivity.data.LessonActivitiesQuestions.length > 0) {
              responseActivity.data.LessonActivitiesQuestions.forEach(
                (activityQuestion: HandledActivityTypes['LessonActivitiesQuestions'][number]) => {
                  if (activityQuestion.question?.length > 0) {
                    let answerLength =
                      activityQuestion.question[0].StudentAnsAttempts.length

                    if (isHomework) {
                      if (answerLength <= 0) {
                        handleResetTimer()
                      }
                    } else {
                      if (answerLength <= 0) {
                        fetchAttendanceData()
                        handleResetTimer()
                      }
                    }
                  } else {
                    toast.error("Question data not found", {
                      autoClose: 3000, // 3 seconds
                      onClose: () => {
                        history.back() // Navigate back in history after toast is closed
                      },
                    })
                  }
                }
              )
              setActivityData(responseActivity.data)
            } else {
              toast.error("Question data not found", {
                autoClose: 3000,
                onClose: () => {
                  history.back()
                },
              })
              setActivityData(undefined)
            }
          })
          .catch(error => {
            setLoader(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setLoader(false)
        window.history.back()
      }
    } else {
      navigate("/login")
    }
  }

  //task


  const [isTaskSubmit, setTaskSubmit] = useState(false)

  function submitTaskAnswer() {
    if (authUser && authUser != "" && authUser != null) {
      setTaskSubmit(true)
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentAnswer/submitAttemptOneTime", {
          // activity_type: activityData!.activity_type,
          lessonKey: activityData!.fk_lesson_key,
          lessonActivityKey: activityData!.pk_lesson_activity_key,
          // fk_sub_id: activityData!.fk_sub_id,
          questionId: activityData!.LessonActivitiesQuestions[0].fk_question_id,
          timeTakenSeconds: seconds,
          // fk_ses_key: activityData!.fk_sest_key,
          // coins: activityData!.activity_node?.length > 0
          //         ? activityData!.activity_node[0].coins
          //         : 2,
        })
        .then(response => {
          if (parseInt(response.data) === 1) {
            setTaskSubmit(false)
            fetchData()
          } else {
            setTaskSubmit(false)
            fetchData()
          }
        })
        .catch(error => {
          setTaskSubmit(false)
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    } else {
      setTaskSubmit(false)
      navigate("/login")
    }
  }

  //Avathr image functionality
  //useEffect
  const [userGender, setUserGender] = useState(
    localStorage.getItem("usergender") || null
  )
  //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'
  const [maleAvatarData, setMaleAvatarData] = useState([])
  const [femaleAvatarData, setFemaleAvatarData] = useState([])

  const [AvatarGendar, setAvatarGendar] = useState(
    localStorage.getItem("usergender") === "Female" ? true : false
  )
  useEffect(() => {
    if (userGender && userGender == "Male") {
      setAvatarGendar(false)
    } else if (userGender && userGender == "Female") {
      setAvatarGendar(true)
    } else {
      setAvatarGendar(false)
    }
  }, [userGender])
  useEffect(() => {
    fetchStudentAvatarData()
  }, [])
  const togAvatarGendar = () => {
    setAvatarGendar(!AvatarGendar)
  }

  const properties = {
    prevArrow: (
      <button className="prev-btn">
        <i className="fas fa-arrow-circle-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="next-btn">
        <i className="fas fa-arrow-circle-right"></i>
      </button>
    ),
  }
  //resource male
  const [maleAvatarHeadData, setMaleAvatarHeadData] = useState<AvatarData>()
  const [maleAvatarArmourData, setMaleAvatarArmourData] = useState<AvatarData>()
  const [maleAvatarHandData, setMaleAvatarHandData] = useState<AvatarData>()
  const [maleAvatarWeaponData, setMaleAvatarWeaponData] = useState<AvatarData>()
  const [maleAvatarPetData, setMaleAvatarPetData] = useState<AvatarData>()

  //resource female
  const [femaleAvatarHeadData, setFemaleAvatarHeadData] = useState<AvatarData>()
  const [femaleAvatarArmourData, setFemaleAvatarArmourData] = useState<AvatarData>()
  const [femaleAvatarHandData, setFemaleAvatarHandData] = useState<AvatarData>()
  const [femaleAvatarWeaponData, setFemaleAvatarWeaponData] = useState<AvatarData>()
  const [femaleAvatarPetData, setFemaleAvatarPetData] = useState<AvatarData>()

  const fetchStudentAvatarData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentAvatar/StudentAvatarDeatils", {})
        .then(responseAvatar => {
          if (responseAvatar.data != "") {
            if (responseAvatar.data.maleInventory.length > 0) {
              setMaleAvatarData(responseAvatar.data.maleInventory)

              //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'

              const filteredMaleHeadArray =
                responseAvatar.data.maleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 0
                )
              if (filteredMaleHeadArray.length > 0) {
                setMaleAvatarHeadData(filteredMaleHeadArray[0])
              } else {
                setMaleAvatarHeadData(undefined)
              }

              const filteredMaleArmourArray =
                responseAvatar.data.maleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 1
                )
              if (filteredMaleArmourArray.length > 0) {
                setMaleAvatarArmourData(filteredMaleArmourArray[0])
              } else {
                setMaleAvatarArmourData(undefined)
              }

              const filteredMaleHandArray =
                responseAvatar.data.maleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 2
                )
              if (filteredMaleHandArray.length > 0) {
                setMaleAvatarHandData(filteredMaleHandArray[0])
              } else {
                setMaleAvatarHandData(undefined)
              }

              const filteredMaleWeaponArray =
                responseAvatar.data.maleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 3
                )
              if (filteredMaleWeaponArray.length > 0) {
                setMaleAvatarWeaponData(filteredMaleWeaponArray[0])
              } else {
                setMaleAvatarWeaponData(undefined)
              }

              const filteredMalePetArray =
                responseAvatar.data.maleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 4
                )
              if (filteredMalePetArray.length > 0) {
                setMaleAvatarPetData(filteredMalePetArray[0])
              } else {
                setMaleAvatarPetData(undefined)
              }
            } else {
              setMaleAvatarData([])
              setMaleAvatarHeadData(undefined)
              setMaleAvatarArmourData(undefined)
              setMaleAvatarHandData(undefined)
              setMaleAvatarWeaponData(undefined)
              setMaleAvatarPetData(undefined)
            }

            if (responseAvatar.data.femaleInventory.length > 0) {
              setFemaleAvatarData(responseAvatar.data.femaleInventory)
              //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'

              const filteredFeMaleHeadArray =
                responseAvatar.data.femaleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 0
                )
              if (filteredFeMaleHeadArray.length > 0) {
                setFemaleAvatarHeadData(filteredFeMaleHeadArray[0])
              } else {
                setFemaleAvatarHeadData(undefined)
              }

              const filteredFeMaleArmourArray =
                responseAvatar.data.femaleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 1
                )
              if (filteredFeMaleArmourArray.length > 0) {
                setFemaleAvatarArmourData(filteredFeMaleArmourArray[0])
              } else {
                setFemaleAvatarArmourData(undefined)
              }

              const filteredFeMaleHandArray =
                responseAvatar.data.femaleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 2
                )
              if (filteredFeMaleHandArray.length > 0) {
                setFemaleAvatarHandData(filteredFeMaleHandArray[0])
              } else {
                setFemaleAvatarHandData(undefined)
              }

              const filteredFeMaleWeaponArray =
                responseAvatar.data.femaleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 3
                )
              if (filteredFeMaleWeaponArray.length > 0) {
                setFemaleAvatarWeaponData(filteredFeMaleWeaponArray[0])
              } else {
                setFemaleAvatarWeaponData(undefined)
              }

              const filteredFeMalePetArray =
                responseAvatar.data.femaleInventory.filter(
                  // @ts-ignore
                  item => parseInt(item.resource_type) === 4
                )
              if (filteredFeMalePetArray.length > 0) {
                setFemaleAvatarPetData(filteredFeMalePetArray[0])
              } else {
                setFemaleAvatarPetData(undefined)
              }
            } else {
              setFemaleAvatarData([])
              setFemaleAvatarHeadData(undefined)
              setFemaleAvatarArmourData(undefined)
              setFemaleAvatarHandData(undefined)
              setFemaleAvatarWeaponData(undefined)
              setFemaleAvatarPetData(undefined)
            }
          } else {
            setMaleAvatarData([])
            setMaleAvatarHeadData(undefined)
            setMaleAvatarArmourData(undefined)
            setMaleAvatarHandData(undefined)
            setMaleAvatarWeaponData(undefined)
            setMaleAvatarPetData(undefined)

            setFemaleAvatarData([])
            setFemaleAvatarHeadData(undefined)
            setFemaleAvatarArmourData(undefined)
            setFemaleAvatarHandData(undefined)
            setFemaleAvatarWeaponData(undefined)
            setFemaleAvatarPetData(undefined)
          }
        })
        .catch(error => {
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    } else {
      navigate("/login")
    }
  }

  // Function to add "character_" prefix to filename
  const modifyUrl = (url: string) => {
    const parts = url.split("/")
    const filename = parts[parts.length - 1]
    const modifiedFilename = `character_${filename}`
    parts[parts.length - 1] = modifiedFilename
    return parts.join("/")
  }
  const ReDirectProfile = async () => {
    navigate("/profile")
  }
  // student avatar system

  const handleHomeworkClick = () => {
    const filterState = location?.state || ""
    navigate("/homework-list", {
      state: {
        filterState,
      },
    })
  }
  return (
    <React.Fragment>
      <Loader show={loader} type="body"/>
      <ToastContainer autoClose={3000} />
      <div className="page-wrapper">
        <div className="cs-pg-header bg-dark-blue py-4">
          <Container className="custom-wt">
            <div className="d-flex align-items-center">
              <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
                {isHomework ? (
                  <div
                    className="text-white font-size-14 text-uppercase cursor-pointer"
                    onClick={handleHomeworkClick}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    BACK TO HOMEWORK
                  </div>
                ) : (
                  <div
                    className="text-white font-size-14 text-uppercase"
                    onClick={() => history.back()}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    Back
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                  {/*{activityData &&*/}
                  {/*activityData.activity_node &&*/}
                  {/*activityData.activity_node.length > 0 &&*/}
                  {/*activityData.activity_node[0].name*/}
                  {/*  ? activityData.activity_node[0].name*/}
                  {/*  : null}*/}
                  {ActivityUtil.activityName(activityData)}
                </h6>
                <p className="mb-0 text-uppercase luminous-wht">
                  {" "}
                  <span className="text-yellow me-1">
                    {activityData?.subject_name}
                  </span>{" "}
                  Task{" "}
                </p>
                <div className="luminous-wht font-size-16">
                  <img width={24} className="" src={awicon} alt="" />{" "}
                  {activityData?.coins_earned ? activityData.coins_earned : 0}
                  /
                  {activityData?.activity_node?.[0]?.coins || 2}{" "}
                  coins
                </div>
              </div>
            </div>
          </Container>
        </div>

        {activityData?.LessonActivitiesQuestions?.map(
              (questionActivity, activeindex) => {
                if (questionActivity.question?.length > 0) {
                  return questionActivity.question.map(
                    (InnerActivityData, index) => {
                      if (index === 0) {
                        return (
                          <Container className="custom-wt">
                            <div className={`assessement-section summary-width-hold mt-4 ${localStorage.getItem("is_fontsize") === "1" ? 'stu-custom-font-size' : ''}`}>
                              <div className="hw-list mt-4 pb-100">
                                <ul className="list-unstyled mb-0">
                                  <li className="justify-content-between">
                                    <div className="d-flex align-items-start gap-4 justify-content-end">
                                      <div className="mb-0 d-flex align-items-center gap-2">
                                        <p className="mb-0">
                                          #
                                          {InnerActivityData.pk_onetime_activity_id
                                            ? InnerActivityData.pk_onetime_activity_id
                                            : null}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
                                      {InnerActivityData.StudentAnsAttempts
                                        .length <= 0 ? (
                                        <Button
                                          className="btn btn-danger cs-btn-danger mt-1 text-uppercase"
                                          disabled={isTaskSubmit}
                                          onClick={() => submitTaskAnswer()}
                                        >
                                          Complete Activity{" "}
                                          {
                                            activityData.tut_clock_is_active
                                           != 1
                                            ? formatTime(seconds)
                                            : ""}
                                        </Button>
                                      ) : (
                                        <p></p>
                                      )}
                                    </div>
                                    <div className="video-wrapper">
                                      <h4>
                                        {InnerActivityData.name
                                          ? InnerActivityData.name
                                          : "No task"}
                                      </h4>
                                      <p className="font-size-16 fw-semibold mb-2 mt-2">
                                        {activityData?.marked_for_homework >= 0 && (
                                          <>
                                            {activityData?.homework_tutor_message && activityData.marked_for_homework == 1 ? (
                                              <>
                                                <b>Tutor message:</b> {activityData.homework_tutor_message}
                                              </>
                                            ) : activityData?.lesson_tutor_message ? (
                                              <>
                                                <b>Tutor message:</b> {activityData.lesson_tutor_message}
                                              </>
                                            ) : null}
                                          </>
                                        )}
                                      </p>
                                      <p className="font-size-16 fw-semibold mb-2">
                                        {activityData?.tutor_comments && (
                                          <>
                                            <b>Tutor comments:</b>{" "}
                                            {activityData.tutor_comments}
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                </ul>
                              </div>

                              {InnerActivityData.StudentAnsAttempts.length >
                              0 ? (
                                <div className="navigator-wrapper position-relative mt-5">
                                  <div className="nv-dg-smile-avatar">
                                    {/* <img width={400} src={dsmile} alt="" /> */}
                                    <div className="avatar-wrapper">
                                      {/* student avatar start */}
                                      <div className="super-profile_wrapper img-consolidate-display">
                                        <div className="content-left">
                                          <div className="super-avatar-display">
                                            {/* male functionality start */}
                                            {!AvatarGendar ? (
                                              <div className="each-slide-effect cursor-pointer">
                                                <div className="pirate-media male position-relative">
                                                  <div className="avatar-display text-center position-relative">
                                                    <div className="avatar-default">
                                                      <img
                                                        width={450}
                                                        className=""
                                                        src={piratemale}
                                                        alt=""
                                                      />
                                                    </div>
                                                    <div className="avatar-attachments">
                                                      {maleAvatarHeadData &&
                                                      maleAvatarHeadData.image ? (
                                                        <div className="head-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={modifyUrl(
                                                              maleAvatarHeadData.image
                                                            )}
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {maleAvatarArmourData &&
                                                      maleAvatarArmourData.image ? (
                                                        <div className="dress-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              maleAvatarArmourData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {maleAvatarPetData &&
                                                      maleAvatarPetData.image ? (
                                                        <div className="companion-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              maleAvatarPetData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {maleAvatarHandData &&
                                                      maleAvatarHandData.image ? (
                                                        <>
                                                          <div className="hand-float position-absolute">
                                                            <img
                                                              className=""
                                                              src={
                                                                maleAvatarHandData.image
                                                              }
                                                              alt=""
                                                            />
                                                          </div>

                                                          <div className="hand-float-revert position-absolute">
                                                            <img
                                                              className=""
                                                              src={
                                                                maleAvatarHandData.image
                                                              }
                                                              alt=""
                                                            />
                                                          </div>
                                                        </>
                                                      ) : null}

                                                      {maleAvatarWeaponData &&
                                                      maleAvatarWeaponData.image ? (
                                                        <div className="weapon-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              maleAvatarWeaponData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="each-slide-effect cursor-pointer">
                                                <div className="pirate-media female position-relative">
                                                  <div className="avatar-display text-center position-relative">
                                                    <div className="avatar-default">
                                                      <img
                                                        width={450}
                                                        className=""
                                                        src={piratefemale}
                                                        alt=""
                                                      />
                                                    </div>
                                                    <div className="avatar-attachments">
                                                      {femaleAvatarHeadData &&
                                                      femaleAvatarHeadData.image ? (
                                                        <div className="head-float female-hd position-absolute">
                                                          <img
                                                            className=""
                                                            src={modifyUrl(
                                                              femaleAvatarHeadData.image
                                                            )}
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {femaleAvatarArmourData &&
                                                      femaleAvatarArmourData.image ? (
                                                        <div className="dress-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              femaleAvatarArmourData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {femaleAvatarPetData &&
                                                      femaleAvatarPetData.image ? (
                                                        <div className="companion-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              femaleAvatarPetData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}

                                                      {femaleAvatarHandData &&
                                                      femaleAvatarHandData.image ? (
                                                        <>
                                                          <div className="hand-float position-absolute">
                                                            <img
                                                              className=""
                                                              src={
                                                                femaleAvatarHandData.image
                                                              }
                                                              alt=""
                                                            />
                                                          </div>
                                                          <div className="hand-float-revert position-absolute">
                                                            <img
                                                              className=""
                                                              src={
                                                                femaleAvatarHandData.image
                                                              }
                                                              alt=""
                                                            />
                                                          </div>
                                                        </>
                                                      ) : null}

                                                      {femaleAvatarWeaponData &&
                                                      femaleAvatarWeaponData.image ? (
                                                        <div className="weapon-float position-absolute">
                                                          <img
                                                            className=""
                                                            src={
                                                              femaleAvatarWeaponData.image
                                                            }
                                                            alt=""
                                                          />
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {/* Female functionality end */}
                                            {/* </Slide> */}
                                          </div>
                                        </div>
                                      </div>

                                      {/* student avatar end */}
                                    </div>
                                  </div>
                                  <div className="navigator-nxt">
                                    {InnerActivityData.duration &&
                                    InnerActivityData.duration != "" ? (
                                      <p className="opacity-75">
                                        SUGGESTED TIME:{" "}
                                        {InnerActivityData.duration
                                          ? InnerActivityData.duration
                                          : null}
                                      </p>
                                    ) : null}
                                    <p className="font-size-16 d-flex align-items-center gap-2">
                                      <img width={24} src={awicon} />{" "}
                                      {activityData && activityData.coins_earned
                                        ? activityData.coins_earned
                                        : 0}
                                      /
                                      {activityData &&
                                        activityData.activity_node &&
                                        activityData.activity_node.length > 0 &&
                                        activityData.activity_node[0].coins
                                          ? activityData.activity_node[0].coins
                                          : 2}{" "}
                                      coins
                                    </p>

                                    {isHomework ? (
                                      <Button
                                        className="btn btn-danger cs-btn-danger mt-1"
                                        // onClick={() => history.back()}
                                        onClick={handleHomeworkClick}
                                      >
                                        BACK TO HOMEWORK
                                      </Button>
                                    ) : (
                                      <Button
                                        className="btn btn-danger cs-btn-danger mt-1"
                                        onClick={() => history.back()}
                                      >
                                        BACK TO LESSON PLAN
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </Container>
                        )
                      }
                    }
                  )
                }
              }
            )
        }
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(OneTimeActivity)
